/*
 * @Author: Gaho
 * @Date: 2023-12-27 17:48:22
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-28 14:10:49
 */
/**
 * 将数组翻转&&将翻转后的第一个偶数删除
 * @param {object} sounds 要翻转的数据
 * @returns 翻转后的数组
 */
const copyReserve = (sounds) => {
    for (const i in sounds) {
        const item = [...sounds[i]]
        const reserveItem = sounds[i].reverse();
        Number(i) % 2 === 0 && reserveItem.shift(),
        sounds[i] = [...item, ...reserveItem]
    }
    return sounds;
}
export const oddsData = {
    // risk-low
    'Low': {
        8: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.3906
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 3.125
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 10.9375
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 21.875
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 27.3438
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 21.875
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 10.9375
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 3.125
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.3906
            }
        ],
        9: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.1953
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 1.7578
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 7.0313
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 16.4063
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 16.4063
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 7.0313
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 1.7578
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.1953
            }
        ],
        10: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0977
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.9677
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 4.3945
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 11.7188
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 20.5078
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 20.5078
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 11.7188
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 4.3945
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.9677
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0977
            }
        ],
        11: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0488
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.5371
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 2.6855
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 8.0566
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 16.1133
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 16.1133
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 8.0566
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 2.6855
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.5371
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0488
            }
        ],
        12: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.293
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 1.6113
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 5.3711
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 12.085
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 19.3359
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 19.3359
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 12.085
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 5.3711
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 1.6113
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.293
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0244
            }
        ],
        13: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0122
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.1587
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 0.9521
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 3.4912
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 8.728
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 15.7104
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 15.7104
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 8.728
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 3.4912
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 0.9521
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.1587
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0122
            }
        ],
        14: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0061
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.0854
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.5554
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 2.2217
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 6.1096
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 18.3289
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 18.3289
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 6.1096
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 2.2217
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.5554
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.0854
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0061
            }
        ],
        15: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0031
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.0458
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.3204
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 1.3885
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 4.1656
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 9.1644
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 15.274
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 15.274
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 9.1644
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 4.1656
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 1.3885
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.3204
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.0458
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0031
            }
        ],
        16: [
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0015
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.1831
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.8545
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 2.7771
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 6.665
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 17.4561
            },
            {
                mutil: 0,
                color: '#55A3FF',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 17.4561
            },
            {
                mutil: 0,
                color: '#3994FF',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 6.665
            },
            {
                mutil: 0,
                color: '#0075FF',
                chance: 2.7771
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.8545
            },
            {
                mutil: 0,
                color: '#0059DF',
                chance: 0.1831
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#0443A1',
                chance: 0.0015
            }
        ]
    },
    // risk-meduim
    'Medium': {
        8: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.3906
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 3.125
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 10.9375
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 21.875
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 27.3438
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 21.875
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 10.9375
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 3.125
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.3906
            }
        ],
        9: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.1953
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 1.7578
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 7.0313
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 16.4063
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 16.4063
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 7.0313
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 1.7578
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.1953
            }
        ],
        10: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0977
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.9677
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 4.3945
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 11.7188
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 20.5078
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 20.5078
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 11.7188
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 4.3945
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.9677
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0977
            }
        ],
        11: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0488
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.5371
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 2.6855
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 8.0566
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 16.1133
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 16.1133
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 8.0566
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 2.6855
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.5371
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0488
            }
        ],
        12: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.293
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 1.6113
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 5.3711
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 12.085
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 19.3359
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 19.3359
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 12.085
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 5.3711
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 1.6113
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.293
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0244
            }
        ],
        13: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0122
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.1587
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 0.9521
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 3.4912
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 8.728
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 15.7104
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 15.7104
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 8.728
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 3.4912
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 0.9521
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.1587
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0122
            }
        ],
        14: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0061
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.0854
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.5554
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 2.2217
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 6.1096
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 18.3289
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 18.3289
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 6.1096
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 2.2217
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.5554
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.0854
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0061
            }
        ],
        15: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0031
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.0458
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.3204
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 1.3885
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 4.1656
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 9.1644
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 15.274
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 15.274
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 9.1644
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 4.1656
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 1.3885
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.3204
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.0458
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0031
            }
        ],
        16: [
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0015
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.1831
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.8545
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 2.7771
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 6.665
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 17.4561
            },
            {
                mutil: 0,
                color: '#9DB702',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 17.4561
            },
            {
                mutil: 0,
                color: '#75AB02',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 6.665
            },
            {
                mutil: 0,
                color: '#539400',
                chance: 2.7771
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.8545
            },
            {
                mutil: 0,
                color: '#258702',
                chance: 0.1831
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#095C21',
                chance: 0.0015
            }
        ]
    },
    // risk-high
    'High': {
        8: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.3906
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 3.125
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 10.9375
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 21.875
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 27.3438
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 21.875
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 10.9375
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 3.125
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.3906
            }
        ],
        9: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.1953
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 1.7578
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 7.0313
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 16.4063
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 16.4063
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 7.0313
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 1.7578
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.1953
            }
        ],
        10: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0977
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.9677
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 4.3945
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 11.7188
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 20.5078
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 24.6094
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 20.5078
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 11.7188
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 4.3945
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.9677
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0977
            }
        ],
        11: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0488
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.5371
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 2.6855
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 8.0566
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 16.1133
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 16.1133
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 8.0566
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 2.6855
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.5371
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0488
            }
        ],
        12: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.293
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 1.6113
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 5.3711
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 12.085
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 19.3359
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 22.5586
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 19.3359
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 12.085
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 5.3711
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 1.6113
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.293
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0244
            }
        ],
        13: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0122
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.1587
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 0.9521
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 3.4912
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 8.728
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 15.7104
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 15.7104
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 8.728
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 3.4912
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 0.9521
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.1587
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0122
            }
        ],
        14: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0061
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.0854
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.5554
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 2.2217
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 6.1096
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 18.3289
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 20.9473
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 18.3289
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 6.1096
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 2.2217
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.5554
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.0854
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0061
            }
        ],
        15: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0031
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.0458
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.3204
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 1.3885
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 4.1656
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 9.1644
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 15.274
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 15.274
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 9.1644
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 4.1656
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 1.3885
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.3204
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.0458
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0031
            }
        ],
        16: [
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0015
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.1831
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.8545
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 2.7771
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 6.665
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 17.4561
            },
            {
                mutil: 0,
                color: '#FB983D',
                chance: 19.6381
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 17.4561
            },
            {
                mutil: 0,
                color: '#FB763D',
                chance: 12.2192
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 6.665
            },
            {
                mutil: 0,
                color: '#F15634',
                chance: 2.7771
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.8545
            },
            {
                mutil: 0,
                color: '#ED4520',
                chance: 0.1831
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0244
            },
            {
                mutil: 0,
                color: '#ED2020',
                chance: 0.0015
            }
        ]
    },
    // 声音相关数据
    sounds: copyReserve({
        16: [0, 0, 1, 1, 2, 2, 3, 3, 4],
        15: [0, 1, 1, 2, 2, 3, 3, 4],
        14: [0, 1, 1, 2, 2, 3, 3, 4],
        13: [0, 1, 2, 2, 3, 3, 4],
        12: [0, 1, 2, 2, 3, 3, 4],
        11: [0, 1, 2, 2, 3, 4],
        10: [0, 1, 2, 2, 3, 4],
        9: [0, 1, 2, 3, 4],
        8: [0, 1, 2, 3, 4]
    }),
    // 行数
    rowsOptions: [8, 9, 10, 11, 12, 13, 14, 15, 16],
    dropDownrowsOptions: [{
        name: 8,
        value: 8,
    },{
        name: 9,
        value: 9,
    },{
        name: 10,
        value: 10,
    },{
        name: 11,
        value: 11,
    },{
        name: 12,
        value: 12,
    },{
        name: 13,
        value: 13,
    },{
        name: 14,
        value: 14,
    },{
        name: 15,
        value: 15,
    },{
        name: 16,
        value: 16,
    }],
}

export function fnDataSetter(
    odds, // 赋值目标 
    wins_map, // 线上数据 
){
    if (!wins_map.length) return;
    toMatch('Low', wins_map[0]); // 2个参数要严格对应 
    toMatch('Medium', wins_map[1]);
    toMatch('High', wins_map[2]);
    function toMatch(sDifficulty, oOnline){
        const oLocal = odds[sDifficulty]; 
        // console.log(`${sDifficulty} ----------------------------- ↓`); 
        for (const [rowCount, aPit] of Object.entries(oLocal) as any){
            const aPitOnline = oOnline[rowCount];
            // console.log(`${sDifficulty} 子规格： ${rowCount}行，${aPit.length}坑`);
            if (aPit.length != aPitOnline.length){
                console.error(`坑数量不匹配，本地与线上坑数量：`, aPit.length, aPitOnline.length);
            }
            aPit.forEach((oPit, idx) => {
                oPit.mutil = aPitOnline[idx]; // 为返现倍数赋值 
            });
        }
        // console.log(`${sDifficulty} 赋值完毕：`, deepCopy(oLocal)); 
    }
}

export const rulesData = [
    {
        content1: 'plinkoRule1',
        constent2: '',
        img: null,
    }
]
export const lettersList = ['P', '', '', 'L', '', '', 'I', '', '', '', 'N', '', '', 'K', '', '', 'O']
export type oddsDataType = typeof oddsData;
